<h1>{{title.getTitle()}}</h1>
<hr />

<pcg-table #table dataSource='api/Silkier/SilkierHistory/GetHistory' [multipleSearch]='false'
  [columnDefs]='columns' [pcgSort]='[["actualFireTimeUtcStr", "desc"]]' [canExactMatchSearch]="false">

  <ng-container cdkColumnDef="schedulerName">
    <th cdk-header-cell pcg-sort-header *cdkHeaderCellDef>{{ columns.get('schedulerName').displayName}}</th>
    <td cdk-cell *cdkCellDef='let row' data-label="Scheduler Name">{{row.schedulerName}}</td>
  </ng-container>

  <ng-container cdkColumnDef="job">
    <th cdk-header-cell pcg-sort-header *cdkHeaderCellDef>{{ columns.get('job').displayName}}</th>
    <td cdk-cell *cdkCellDef='let row' data-label="Job">{{row.job}}</td>
  </ng-container>

  <ng-container cdkColumnDef="trigger">
    <th cdk-header-cell pcg-sort-header *cdkHeaderCellDef>{{ columns.get('trigger').displayName}}</th>
    <td cdk-cell *cdkCellDef='let row' data-label="Trigger">{{row.trigger}}</td>
  </ng-container>

  <ng-container cdkColumnDef="scheduledFireTimeUtcStr">
    <th cdk-header-cell pcg-sort-header *cdkHeaderCellDef>{{ columns.get('scheduledFireTimeUtcStr').displayName}}</th>
    <td cdk-cell *cdkCellDef='let row' data-label="Scheduled Fire Time">{{row.scheduledFireTimeUtcStr}}</td>
  </ng-container>

  <ng-container cdkColumnDef="actualFireTimeUtcStr">
    <th cdk-header-cell pcg-sort-header *cdkHeaderCellDef>{{ columns.get('actualFireTimeUtcStr').displayName}}</th>
    <td cdk-cell *cdkCellDef='let row' data-label="Actual Fire Time">{{row.actualFireTimeUtcStr}}</td>
  </ng-container>

  <ng-container cdkColumnDef="recovering">
    <th cdk-header-cell pcg-sort-header *cdkHeaderCellDef>{{ columns.get('recovering').displayName}}</th>
    <td cdk-cell *cdkCellDef='let row' data-label="Recovering">{{row.recovering}}</td>
  </ng-container>

  <ng-container cdkColumnDef="finishedTimeUtcStr">
    <th cdk-header-cell pcg-sort-header *cdkHeaderCellDef>{{ columns.get('finishedTimeUtcStr').displayName}}</th>
    <td cdk-cell *cdkCellDef='let row' data-label="Finished Time">{{row.finishedTimeUtcStr}}</td>
  </ng-container>

  <ng-container cdkColumnDef="logMessage">
    <th cdk-header-cell *cdkHeaderCellDef>{{ columns.get('logMessage').displayName }}</th>
    <td cdk-cell *cdkCellDef='let row' data-label="Log">
      <div (click)='viewLogMessage(row.fireInstanceId);' class="block-link">View Log</div>
    </td>
  </ng-container>

  <ng-container cdkColumnDef="exceptionMessage">
    <th cdk-header-cell *cdkHeaderCellDef>{{ columns.get('exceptionMessage').displayName }}</th>
    <td cdk-cell *cdkCellDef='let row' data-label="Exception">
      @if (!row.wasSuccessful) {
        <div (click)='viewExceptionMessage(row.fireInstanceId);' class="block-link">View Exception</div>
      }
    </td>
  </ng-container>

</pcg-table>
